/* eslint-disable array-bracket-newline */
import Image from '../../atoms/Image';
import Text from '../../atoms/Text';
import arrowLeft from '../../assets/images/arrow_left.svg';
import arrowRight from '../../assets/images/arrow_right.svg';

import './styles.scss';

interface IProps {
  page: number;
  setPage: (val: number) => void;
  maxPage: number;
}

const Pagination = (props: IProps) => {
  const getPages = () => {
    const { page, maxPage } = props;

    if (maxPage < 7) {
      return Array.from({ length: maxPage - 1 }, (_, index) => index + 1).slice(
        1
      );
    }

    if (page < 4) {
      return [2, 3, 4, 5, 6];
    }

    if (page > maxPage - 3) {
      return [maxPage - 5, maxPage - 4, maxPage - 3, maxPage - 2, maxPage - 1];
    }

    if (page >= 4 && page <= maxPage - 3) {
      return [page - 2, page - 1, page, page + 1, page + 2];
    }

    return [];
  };

  const onPrev = () => {
    if (props.page > 1) {
      props.setPage(props.page - 1);
    }
  };

  const onNext = () => {
    if (props.page < props.maxPage) {
      props.setPage(props.page + 1);
    }
  };

  const values = getPages();

  return (
    <div className='pagination' onMouseDown={(e) => e.preventDefault()}>
      <div
        className={`prev${props.page > 1 ? ' prev--active' : ''}`}
        onClick={onPrev}
      >
        <Image src={arrowLeft} size='s' />
        <Text size={12}>Prev</Text>
      </div>

      <div
        className={`button button--1 ${
          props.page === 1 ? 'button--active' : ''
        }`}
        onClick={() => props.setPage(1)}
      >
        1
      </div>

      {props.page > 4 && (
        <Text size={14} className='dots'>
          ...
        </Text>
      )}

      {values.map((item) => (
        <div
          key={item}
          className={`button button--${item.toString().length} ${
            props.page === item ? 'button--active' : ''
          }`}
          onClick={() => props.setPage(item)}
        >
          {item}
        </div>
      ))}

      {!!values.length && !values.includes(props.maxPage - 1) && (
        <Text size={14} className='dots'>
          ...
        </Text>
      )}

      {props.maxPage !== 1 && (
        <div
          className={`button button--${props.maxPage.toString().length} ${
            props.page === props.maxPage ? 'button--active' : ''
          }`}
          onClick={() => props.setPage(props.maxPage)}
        >
          {props.maxPage}
        </div>
      )}
      <div
        className={`next${props.page < props.maxPage ? ' next--active' : ''}`}
        onClick={onNext}
      >
        <Text size={12}>Next</Text>
        <Image src={arrowRight} size='s' />
      </div>
    </div>
  );
};

export default Pagination;
